import { Directive, HostBinding } from '@angular/core';
import { ConnectionService } from '../../core/services/connection.service';


/**
 * Directive to disable DOM elements when offline mode is activated
 */
@Directive({
    selector: '[rmsOfflineDisable]',
    standalone: false
})
export class OfflineDisableDirective {

  @HostBinding('disabled') isDisabled: boolean;

  constructor(
    private connectionService: ConnectionService
  ) {
    this.connectionService.monitor().subscribe(isConnected => this.isDisabled = !isConnected);
  }

}
